import React from 'react'
import Sign_out_squre from "../../../../assets/images/Sign_out_squre.svg";
import question from "../../../../assets/images/question.svg"
import mypaymentdashboard from "../../../../assets/images/intarestdashboard.svg"
import { Footer } from '../../../common/footer/footer';
import Sidebar from "../sidebar/sidebar.js";
import { MyPaymentCard } from "../../../common/myPaymentCard/myPaymentCard";
import { useTranslation } from "react-i18next";
const MyPaymentsJsx = (props) => {
  const {
    paymentData,
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    formSubmitHandler,
    backToAddCard,
    isLoading,
    isShowCard,
    onReplaceCardClick,
    onBackCardClick,
    isCardSummary,
    isPaymentSummary, backToPayment,
    onCompletePayment, invoiceDownload
  } = props;

  const { t } = useTranslation();
  const cardDetails = JSON.parse(localStorage.getItem("addCard"))

  return (
    <>
      <section className="main_customer_dashboard">
        <section className="entiredashboard maincustomerdash expert-dashboard">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <Sidebar />
              </div>
              <div className="col-lg-8 col-sm-8">
                <div className="dashboardrightpanel">
                  <div className="dashboardrightpannerinner">
                    <div className="dashboardrightpannerinnerleft">
                    <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={mypaymentdashboard} /></span>My Payments</h2>
                    {!isShowCard  && !isCardSummary  && !isPaymentSummary && <>   <h2 className="h2_style font-weight-600 d-none d-sm-block">{t("expertDashboard.MY_PAYMENTS_HEADING")}</h2>
                      <h5 className="h5_style">{t("expertDashboard.MY_PAYMENTS_TEXT")}</h5>
                      </>}
                    </div>
                    <div className="dashboardrightpannerinnerright">
                      <div className="signout">
                        <a href="#logout">
                          <img src={question} alt={'icon'} /><span className="title">Help</span>
                        </a>
                      </div>
                      <div className="signout">
                        <a href="#logout">
                          <img src={Sign_out_squre} alt={'icon'} /><span className="title">Logout</span>
                        </a>
                      </div>
                    
                    </div>
                  </div>



                  <MyPaymentCard
                    isShowCard={isShowCard}
                    isCardSummary={isCardSummary}
                    isPaymentSummary={isPaymentSummary}
                    paymentData={paymentData}
                    onReplaceCardClick={onReplaceCardClick}
                    formData={formData}
                    onInputChangeHandler={onInputChangeHandler}
                    onTouchHandler={onTouchHandler}
                    invoiceDownload={invoiceDownload}
                    onBackCardClick={() => onBackCardClick()}
                    formError={formError}
                    formSubmitButtonDisable={formSubmitButtonDisable}
                    formSubmitHandler={formSubmitHandler}
                    isLoading={isLoading}
                    question={question}
                    Sign_out_squre={Sign_out_squre}
                    cardDetails={cardDetails}
                    backToAddCard={backToAddCard} 
                    onCompletePayment={onCompletePayment}
                    backToPayment={backToPayment}
                  />

                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
      </section> 
    </>

  );
};

export default MyPaymentsJsx;